import { NON_PHI_ORGANIZATION_ADMIN, ORGANIZATION_ADMIN } from '@/components/client/constants/roles'
import {
  findIdentityScopeByNormalizedPartnerId,
  getRolesFromScope,
  hasAshAdminRoleInScopes,
  rolesInclude,
  type IdentityScopes,
} from '@/utilities/auth/identityScopeRoles'

export function isPartnerInIdentityScopes(
  scopes: IdentityScopes | null | undefined,
  partnerId: string | null | undefined,
): boolean {
  return findIdentityScopeByNormalizedPartnerId(scopes, partnerId) !== null
}

export function hasOrgAdminRoleForPrimaryPartner(
  scopes: IdentityScopes | null | undefined,
  primaryPartnerId: string | null | undefined,
): boolean {
  const scope = findIdentityScopeByNormalizedPartnerId(scopes, primaryPartnerId)
  if (scope?.is_primary !== true) return false

  return rolesInclude(getRolesFromScope(scope), [ORGANIZATION_ADMIN, NON_PHI_ORGANIZATION_ADMIN])
}

export function canSelectOrgForPrimaryPartner(
  scopes: IdentityScopes | null | undefined,
  primaryPartnerId: string | null | undefined,
): boolean {
  if (!primaryPartnerId) return false
  if (hasAshAdminRoleInScopes(scopes)) return true
  return hasOrgAdminRoleForPrimaryPartner(scopes, primaryPartnerId)
}
